export var Transactiontype;
(function (Transactiontype) {
    Transactiontype["DEPOSIT"] = "DEPOSIT";
    Transactiontype["WITHDRAW"] = "WITHDRAW";
    Transactiontype["REFERALCODE"] = "REFERALCODE";
})(Transactiontype || (Transactiontype = {}));
export var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus["DONE"] = "DONE";
    TransactionStatus["PENDING"] = "PENDING";
    TransactionStatus["BLOCKED"] = "BLOCKED";
})(TransactionStatus || (TransactionStatus = {}));
